import { ReactNode } from 'react';

import { ProfileModel } from '@pukka/api';
import { ActionBar, Button, DropdownValue } from '@pukka/ui-components';
import { Carousel } from 'flowbite-react';
import noop from 'lodash/noop';
import { twMerge } from 'tailwind-merge';

import { OutletSelector } from '../OutletSelector';

interface ActionBarProps {
  readonly pageTitle: string;
  readonly selectedOutlet?: DropdownValue;
  readonly buttonName?: string;
  readonly buttonOnClick?: () => void;
  readonly buttons?: ReactNode;
  readonly outlets?: ProfileModel.Outlet[];
  readonly onOutletChange?: (outlet: ProfileModel.Outlet) => void;
  readonly children?: ReactNode;
  readonly className?: string;
  readonly banner?: string[];
}

const defaultOutlets: ProfileModel.Outlet[] = [];

function DefaultActionBar({
  pageTitle,
  buttonName,
  banner,
  buttons,
  outlets = defaultOutlets,
  selectedOutlet,
  buttonOnClick = noop,
  onOutletChange = noop,
  children,
  className,
}: ActionBarProps) {
  return (
    <ActionBar className={className}>
      <ActionBar.Header title={pageTitle}>
        {buttons}
        {buttonName ? <Button onClick={buttonOnClick}>{buttonName}</Button> : null}
      </ActionBar.Header>
      {banner && banner.length > 0 ? (
        <Carousel slideInterval={9000} className={twMerge('mt-4 h-[calc((100vw/5)-14px)] md:h-[calc(((100vw-240px)/5)-14px)]')}>
          {banner.map((src, idx) => (
            <img key={idx} alt={`banner-${idx}`} src={src} />
          ))}
        </Carousel>
      ) : null}
      <ActionBar.Content>
        {outlets && outlets.length > 0 && selectedOutlet ? (
          <OutletSelector selectedOutlet={selectedOutlet} outlets={outlets} onOutletChange={onOutletChange} />
        ) : null}
        {children}
      </ActionBar.Content>
    </ActionBar>
  );
}

export { DefaultActionBar };
